import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api"
import { toAbsoluteUrl } from "../../../_metronic/_helpers/index.js"
import { ICON_CONSTANTS } from "../../../constants/ImageConstants.js"
import React, { Fragment, useEffect, useRef, useState } from "react"
import SVG from "react-inlinesvg"
import {
  stringFormatting,
  convertDotToComma,
  toThousandConvert
} from "../../../app/helpers/TextHelper.js"
import { timeStampToDate } from "../../../app/helpers/DateHelper.js"
import { GoogleMapKey } from "../../../app/helpers/MapHelper.js"
import { DATE_TYPE_ENUM, INSPECTION_STATUS_ENUM } from "../../../constants/StringConstant.js"

export const ModalMap = ({
  open,
  setOpenMap,
  centroid,
  areas,
  hideDate,
  parse,
  withStatus,
  mapTypeId = "satellite"
}) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GoogleMapKey()
  })
  const mapRef = useRef(null)
  const [center, setCenter] = useState({})
  const [zoom, setZoom] = useState(14)
  const dataMap = []
  const onMapLoad = (map) => {
    mapRef.current = map

    const colorStatus = (status_enum) => {
      switch (status_enum) {
        case INSPECTION_STATUS_ENUM.PASS:
          return "#5EC8F2"
        case INSPECTION_STATUS_ENUM.PARTIAL_PASS:
          return "#F29F05"
        case INSPECTION_STATUS_ENUM.NOT_PASS:
          return "#CC4435"
        default:
          return "#FFFFFF"
      }
    }

    areas.map((item, index) => {
      if (!dataMap[index]) {
        dataMap[index] = {
          coordinates: []
        }
      }
      dataMap[index].area_status_enum = item.area_status_enum
      item.coordinates.map((data) =>
        dataMap[index].coordinates.splice(data.seq, 0, {
          seq: data.seq,
          lat: data.latitude,
          lng: data.longitude
        })
      )

      const polygon = new google.maps.Polygon({
        paths: parse ? dataMap[index].coordinates : item.coordinates,
        strokeColor: "#353535",
        strokeOpacity: 1,
        strokeWeight: 1,
        fillColor: withStatus
          ? colorStatus(parse ? dataMap[index].area_status_enum : item.area_status_enum)
          : "#CC4435",
        fillOpacity: 0.5
      })

      polygon.setMap(map)

      const body =
        `<div class="info-windows"><h5 style="font-family: sans-serif" class="text-center mb-4">` +
        stringFormatting(item.area_code) +
        '</h5><div style="display: flex; flex-direction: column; margin-bottom: 10px;"><div style="display: flex;"><div style="width: 35%; margin-right: 5px;">Lokasi</div><div style="margin-right: 4px; width: 5%">:</div><div style="flex: 1">' +
        stringFormatting(item.location) +
        '</div></div><div style="display: flex;"><div style="width: 35%; margin-right: 5px;">Luas Lahan</div><div style="margin-right: 4px; width: 5%">:</div><div style="flex: 1">' +
        stringFormatting(toThousandConvert(item.land_area_meter)) +
        " m² (" +
        stringFormatting(convertDotToComma(item.land_area_ha)) +
        ' Ha)</div></div><div style="display: flex;"><div style="width: 35%; margin-right: 5px;">Varietas</div><div style="margin-right: 4px; width: 5%">:</div><div style="flex: 1">' +
        stringFormatting(item.variety_name) +
        `${
          hideDate
            ? ""
            : `</div></div><div style="display: flex;"><div style="width: 35%; margin-right: 5px;">Tanggal Tanam</div><div style="margin-right: 4px; width: 5%">:</div><div style="flex: 1">` +
              `${stringFormatting(timeStampToDate(item.planting_date, DATE_TYPE_ENUM.ISO_DATE_ID))}`
        }` +
        "</div></div></div></div>"

      polygon.addListener("click", () => {
        const data = {
          seq: item.centroid.seq,
          lat: item.centroid.latitude,
          lng: item.centroid.longitude
        }
        const infoWindow = new google.maps.InfoWindow()
        infoWindow.setContent(body)
        infoWindow.setPosition(parse ? data : item.centroid)
        infoWindow.open(map)
      })
    })
  }

  useEffect(() => {
    const parsedData = {
      lat: centroid.latitude,
      lng: centroid.longitude,
      seq: centroid.seq
    }
    if (centroid) {
      setCenter(parse ? parsedData : centroid)
      setZoom(17)
    }
  }, [centroid])

  const renderMap = () => {
    return (
      <div className={`modal-map ${open ? "active" : ""}`}>
        <div
          className={"btn-back flex align-items-center cursor-pointer bg-white"}
          onClick={() => setOpenMap(false)}>
          <SVG className="mr-4 mb-1" src={toAbsoluteUrl(ICON_CONSTANTS.ARROW_BACK)} />
          Kembali
        </div>
        <Fragment>
          <GoogleMap
            mapContainerStyle={{
              width: "100vw",
              height: "100vh"
            }}
            zoom={zoom}
            center={center}
            onLoad={(map) => onMapLoad(map)}
            mapTypeId={mapTypeId}>
            {areas.map((item, index) => {
              const centerData = {
                lat: item.centroid.latitude,
                lng: item.centroid.longitude,
                swq: item.centroid.seq
              }
              return (
                <div key={index}>
                  <Marker
                    position={parse ? centerData : item.centroid}
                    label={{
                      text: item.area_code ?? item.name,
                      className: "label-map"
                    }}
                    icon={toAbsoluteUrl(ICON_CONSTANTS.MARKER_TRANSPARENT)}></Marker>
                </div>
              )
            })}
          </GoogleMap>
        </Fragment>
      </div>
    )
  }

  return isLoaded ? renderMap() : null
}